import React from 'react';
import Card from 'components/general/Card/Card';
import GeographySummarySkeleton from 'components/general/GeographySummary/GeographySummarySkeleton';
import getSkeletonItems from 'utils/genSkeletonItems';

const skeletonItems = getSkeletonItems(18, 'geography');

const GeographyGridSkeleton: React.SFC = () => (
  <div className="l-geography-grid">
    {skeletonItems.map(({ id }) => (
      <div className="l-geography-grid__item" key={id}>
        <Card>
          <Card.Section>
            <GeographySummarySkeleton />
          </Card.Section>
        </Card>
      </div>
    ))}
  </div>
);

export default GeographyGridSkeleton;
